export const DOCS_URL = 'https://guide.withvayu.com/documentation/get-started/introduction';